/**
 * Datas do Dashboard de Compras, em DD/MM/AAAA (pedido do Victor, 21/09/2026).
 *
 * 🔴 **Data PURA (`AAAA-MM-DD`) nunca passa por `new Date`**, e este arquivo existe por causa disso.
 *
 * `new Date('2026-08-23')` é interpretado como meia-noite **UTC**; no fuso da oficina (UTC-3) ele
 * volta como 22/08 às 21h, e `toLocaleDateString('pt-BR')` imprimiria **22/08/2026** — um dia antes
 * do que o servidor disse. É a mesma família do defeito que fez a coluna do gráfico dizer 822 e a
 * lista abrir com 846 (at-100): fuso implícito produz erro silencioso, nunca exceção.
 *
 * A janela do painel (`janela.de` / `janela.ate`) é data pura, então ela é formatada por **recorte
 * da string**. Já um instante com hora (`atualizadoEm`, o cadastro da requisição) é ponto no tempo
 * de verdade e aí `new Date` é o certo — são funções diferentes de propósito.
 *
 * 🔴 **A `emissao` e a `previsaoDeEntrega` do PEDIDO são datas puras** (at-121, medido em produção
 * em 06/10/2026: 0 de 10.058 pedidos com hora), apesar de chegarem como ISO completo
 * (`2026-09-18T00:00:00.000Z`). Até a at-121 elas passavam por `new Date` em cinco lugares e
 * apareciam UM DIA ANTES. `formatarDataPura` aceita o ISO completo — use-a para elas.
 */

/**
 * `2026-08-23` → `23/08/2026`, sem tocar em fuso nenhum.
 *
 * Entrada que não tenha o formato esperado volta **como veio**: é melhor exibir o valor cru do
 * servidor do que uma data inventada por um parse que falhou em silêncio.
 */
export function formatarDataPura(iso: string | null | undefined): string {
  if (!iso) return '-';
  const partes = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
  if (!partes) return iso;
  const [, ano, mes, dia] = partes;
  return `${dia}/${mes}/${ano}`;
}

/** Um instante com hora (ISO completo) no fuso de quem está olhando. */
export function formatarInstante(iso: string | null | undefined): string {
  return iso ? new Date(iso).toLocaleDateString('pt-BR') : '-';
}
